import Route from '@ember/routing/route';

export default class SponsoringRoute extends Route {}
